export function getQueryString(queryObj) {
    return queryObj
        ? Object.keys(queryObj)
            .map((key, index) => {
            return index === 0 ? `?${key}=${queryObj[key]}` : `${key}=${queryObj[key]}`;
        })
            .join('&')
        : '';
}
